import { Toast, Dialog, createAPI } from 'cube-ui'
import Request from '@/utils/request'
import Cookies from 'js-cookie'
import router from '@/router'

function isPhone (phone) {
  var t = /^((13[0-9])|(14[5,7,9])|(15([0-3]|[5-9]))|(166)|(17[0,1,3,5,6,7,8])|(18[0-9])|(19[8|9]))\d{8}$/
  return t.test(phone)
}
function message (msg) {
  Dialog.$create({
    type: 'alert',
    title: '消息',
    content: msg
  }).show()
}
function toast (msg) {
  Toast.$create({
    txt: msg,
    type: 'correct'
  }).show()
}
function confirm (msg) {
  return new Promise((resolve, reject) => {
    Dialog.$create({
      type: 'confirm',
      title: '提示',
      content: msg,
      confirmBtn: {
        text: '确定',
        active: true,
        disabled: false,
        href: 'javascript:;'
      },
      cancelBtn: {
        text: '取消',
        active: false,
        disabled: false,
        href: 'javascript:;'
      },
      onConfirm: () => {
        resolve()
      },
      onCancel: () => {
        reject()
      }
    }).show()
  })
}

function request (url, params, data, method) {
  var this_ = this
  return new Promise((resolve, reject) => {
    Request({
      url: url,
      method: method,
      params: params,
      data
    })
      .then(res => {
        if (res.code === 200||res.code===301||res.code===302) {
          resolve(res)
        } else {
          message(res.message || '网络异常')
          reject(res)
        }
      })
      .catch(res => {
        message(res.message || '请求发生了错误')
        reject(res)
      })
  })
}

function post (url, params, data) {
  return request(url, params, data, 'post')
}
function get (url, params) {
  return request(url, params, undefined, 'get')
}
function put (url, params, data) {
  return request(url, params, data, 'put')
}
function go (url, params) {
  router.push({ path: url, query: params })
}
function to (url, params) {
  go(url, params)
}

function myInfo () {
  return new Promise((resolve, reject) => {
    var token = Cookies.get('token')
    if (token) {
      get('/user/my/info')
        .then(res => {
          resolve(res.data)
        })
        .catch(e => {
          reject(e)
        })
    }
  })
}
function logout () {
  console.log('退出账号')
  return new Promise((resolve, reject) => {
    confirm('确定要退出账号吗？')
      .then(() => {
        Cookies.remove('token')
        resolve('确定')
      })
      .catch(() => {
        reject('取消')
      })
  })
}

export default {
  isPhone,
  message,
  confirm,
  toast,
  post,
  get,
  put,
  myInfo,
  logout,
  go,
  to
}



// WEBPACK FOOTER //
// ./src/api/api.js